// src/pages/Privacy.jsx
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import notice from "../legal/privacy-notice.md?raw";

// The public privacy notice. Its text lives in src/legal/privacy-notice.md, exactly as
// approved; change it there, and update its effective date when you publish a change.
const mdComponents = {
  h1: ({ children }) => (
    <h1 className="text-2xl font-bold text-gray-900 mb-3 mt-2">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-xl font-semibold text-gray-900 mb-2 mt-6">{children}</h2>
  ),
  p: ({ children }) => (
    <p className="text-gray-800 leading-7 mb-3">{children}</p>
  ),
  ul: ({ children }) => (
    <ul className="list-disc pl-6 space-y-1 mb-3 text-gray-800">{children}</ul>
  ),
  li: ({ children }) => <li className="leading-7">{children}</li>,
  a: ({ href, children }) => (
    <a href={href} className="text-blue-600 underline hover:text-blue-700 break-words">
      {children}
    </a>
  ),
};

export default function Privacy() {
  return (
    <article className="bg-white rounded-lg shadow p-6 sm:p-8">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={mdComponents}>
        {notice}
      </ReactMarkdown>
    </article>
  );
}
